import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ProductItem, ProductListItem, productDetails } from './product-list-item.model';
import { SlicedDataSource } from '@gh/core-data';
import { ProductRestService } from '@gh/builder-shared-data';
import { GridLayoutService } from '@gh/core-ui-grid';

@Injectable({ providedIn: 'root' })
export class ProductListBusinessService {
  constructor(
    private productRest: ProductRestService,
    private gridLayoutService: GridLayoutService
  ) {}

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('product-list'),
    };
  }

  prepareForCreate(): ProductItem {
    return {
      id: '',
      name: '',
      fee: 0,
      // Add other default fields as needed
    };
  }

  create(product: productDetails): Observable<productDetails> {
    console.log('data-----', product);
    return this.productRest.create(product);
  }
  

  update(product: productDetails, force: boolean = false): Observable<productDetails> {
    return this.productRest.update(product, force);
  }

  get(id: string): Observable<ProductItem> {
    return this.productRest.getById(id);
  }

  deactivate(productId: string, force: boolean = false): Observable<ProductListItem> {
    return this.productRest.deactivate(productId, force);
  }

  findAll(filter?: { showDeleted?: boolean }): Observable<ProductListItem[]> {
    return this.productRest.findAll(filter);
  }

  // Utility methods (mocked for now)
  private isRouteForCreationMode(route: ActivatedRouteSnapshot): boolean {
    // Implement logic to determine creation mode from route
    return route.routeConfig?.path?.includes('new') || false;
  }

  private getRouteParam(route: ActivatedRouteSnapshot, param: string): string | null {
    return route.paramMap.get(param);
  }


  registerProductListLayout() {
   // GridLayoutRegistry.register('product-list', { ... });
  }

  findAllAsDataSource(filter?: { showDeleted?: boolean }): SlicedDataSource<ProductListItem> {
    return this.productRest.findAllAsDataSource(filter);
  }
}

